import React from 'react'
import CloseIcon from "../../../../../src/assets/images/icons/close_icon.svg"
import Refresh_icon from '../../../../assets/images/icons/refresh_button.svg'
import { withTranslation } from "react-i18next";
import { useEffect, useState } from 'react'
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../../helpers/global_helper";
import InfiniteScroll from "react-infinite-scroll-component";
import { formatPrice } from "../../../NumberFormat";
const CoinReward = (props) => {
  const { onClose } = props;
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isItems, setIsitems] = useState(false);



  useEffect(() => {
    fetchRewardData();
  }, []);

  const fetchRewardData = () => {
    let reqData = {
      page: page,
    };
    makeAjax(url.PLAYER_API.getCoinReward, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage("server error No data find", "error", "error");
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      const newData = response.data.reward.data; // Assuming your API returns an array of items
      setItems([...newData]);

      setHasMore(newData.length > 0);
    });
  };

  const handleRefreshBalance = () => {
    fetchRewardData();
    setIsitems(true);
    setTimeout(() => {
      setIsitems(false);
    }, 2000); // 2000 milliseconds = 2 seconds
  };


  const cashOutApiHandle = (id, game_id, coin) => {
    let reqData = {
      id: id,
      gameId: game_id
    };

    makeAjax(url.PLAYER_API.updateReward, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(props.t('internal_err'));
          return;
        }
        showMessage(props.t('trouble_balance'));
        return;
      }

      const cashOutMsg = props.t("cash_out_coin");
      const words = cashOutMsg.split(" ");
      const updatedWords = words.map(word => {
        if (!isNaN(parseInt(word))) {
          return coin.toString();
        } else {
          return word;
        }
      });
      const updatedMsg = updatedWords.join(" ");
      showMessage(updatedMsg, "success", "success")
      fetchRewardData()
      return

    });
  }

  return (
    <div className="information-container">
      <div className="information-inner">
        <div className="information-overlay" onClick={onClose}></div>
        <div className="information">

          <div className="close_info" onClick={onClose}><img src={CloseIcon} alt="" /></div>
          <div className="information-body">
            <h2 >{props.t("coin_reward")}</h2>
            <div class="table_container overflow-y-scroll reward_table_container">
              <InfiniteScroll
                dataLength={items.length}
                next={() => fetchRewardData()}
                hasMore={hasMore}
                endMessage={<p className='text-center'>{props.t("data_not_found")}</p>}
                scrollThreshold={0.7}
                // height={"60vh"}
                style={{ overflow: "inherit", height: "inherit", maxHeight: '60vh' }}
              >
                <table class="table_data coin_reward" width={"100%"}>
                  <thead>
                    <tr>
                      <th  >{props.t("game")} <span class="sorting_arrow">
                      </span>
                      </th>
                      <th  >{props.t("coin")} <span class="sorting_arrow">
                      </span>
                      </th>
                      <th  >{props.t("expired")} <span class="sorting_arrow">
                      </span>
                      </th>
                      <th  >{props.t("remaining_period")} <span class="sorting_arrow">
                      </span>
                      </th>
                      <th  >{props.t("remaining_turnover")} <span class="sorting_arrow">
                      </span>
                      </th>
                      <th  ><img src={Refresh_icon} alt='' className={`coin_refresh ${isItems ? "coin_refresh_ani" : ""}`} onClick={handleRefreshBalance} />
                        <span class="sorting_arrow"></span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {items &&
                      items.map((reward, index) => {
                        const isPeriodZero = parseFloat(reward.period) === 0;
                        const isTurnOverZero = parseFloat(reward.turnover) === 0;
                        const isCoinZero = parseFloat(reward.coin) !== 0;

                        const isButtonEnabled = isPeriodZero && isTurnOverZero && isCoinZero;

                        return (
                          <tr
                            key={index}
                          >
                            <td  >{reward.game_name}</td>
                            <td  >{formatPrice(reward.coin)}</td>
                            <td  >{reward.expired}</td>
                            <td  >{isPeriodZero ? "Achieved" : reward.period}</td>
                            <td  >{isTurnOverZero ? "Achieved" : formatPrice(reward.turnover)}</td>
                            <td className='reward'>
                              <button disabled={!isButtonEnabled} onClick={() => cashOutApiHandle(reward.id, reward.game_id, reward.coin)} className='cash-out-btn'>CASH OUT</button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(CoinReward)
